import { render, staticRenderFns } from "./SiteSetting.vue?vue&type=template&id=1c56808f&scoped=true"
import script from "./SiteSetting.vue?vue&type=script&lang=js"
export * from "./SiteSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c56808f",
  null
  
)

export default component.exports